import { atomWithStorage } from "jotai/utils";
import { StoreKeys } from "./store-keys";
/**
 * Interface for empresa data
 */
export interface Language {
  id: number | string | null;
  name: string;
}

export const languageAtom = atomWithStorage<string | null>(
  `Xtremis_CarbonTech_${StoreKeys.Language}`,
  "en",
);
